import getDecorators from 'inversify-inject-decorators';

import { rootContainer } from '../ioc';

import { LoginStore } from './stores/login.store';

export const loginContainer = rootContainer.createChild();
export const { lazyInject } = getDecorators(loginContainer);

loginContainer.bind(LoginStore).toSelf().inSingletonScope();
